// @ts-nocheck
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

type HasInvalidConfigurationOptionProperty = {
    properties?: {
        hasInvalidConfigurationOption?: string;
    };
};

export const hasInvalidConfigurationOption = (entity?: HasInvalidConfigurationOptionProperty) =>
    getBooleanProperty(entity?.properties?.hasInvalidConfigurationOption);

export const hasInvalidConfigurationCartLine = (cartLines?: HasInvalidConfigurationOptionProperty[] | null) =>
    cartLines?.some(hasInvalidConfigurationOption) ?? false;
